module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "350px",
      "persistent": ""
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('v-btn', {
    staticClass: "orange darken-3",
    attrs: {
      "slot": "activator",
      "dark": "",
      "flat": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "text--lighten-1",
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-card', [_c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_c('h2', [_vm._v("Edit Alert")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.editedAlerts), function(item) {
    return _c('v-flex', {
      key: item.objectName,
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "name": "editedAlertsName",
      "label": "Alert",
      "multi-line": "",
      "id": "editedAlertsName"
    },
    model: {
      value: (_vm.editedAlertsName),
      callback: function($$v) {
        _vm.editedAlertsName = $$v
      },
      expression: "editedAlertsName"
    }
  })], 1)], 1)], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    staticClass: "grey lighten-1 white--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text cyan ",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": _vm.onSaveChanges
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dce8cda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alert/Edit/EditAlertsDialog.vue
// module id = 700
// module chunks = 1